import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthScreen from '../components/AuthScreen';

export default function LoginPage() {
  const navigate = useNavigate();
  return (
    <AuthScreen
      onAuth={() => navigate('/', { replace: true })}
      onSkip={() => navigate('/', { replace: true })}
    />
  );
}
